import NetworkSuppliersCard from '@/components/supplier/NetworkSuppliers/NetworkSuppliersCard';
import ServiceModal from '@/components/modal/ServiceModal';
import SupplierBudget from '@/components/supplier/NetworkSuppliers/SupplierBudget.vue';
import { getSupplierProfileNetwork } from '@/services';
import { getServicesContractors } from '@/services/api/quotation';
import { appendQueryString, getCompetitionPanelStates, getQueryStringByName } from '@/utils/';
import { mapActions, mapState } from 'vuex';
import { MAIN_SERVICES } from '@/utils/constants';
export default {
    name: 'NetworkSuppliers',
    components: { NetworkSuppliersCard, SupplierBudget, ServiceModal },
    data: () => ({
        url: process.env.VUE_APP_STATIC_BASE_URL,
        background: `${process.env.VUE_APP_STATIC_BASE_URL}/newtwork-suppliers-title-bar.png`,
        suppliers: [],
        isMobile: false,
        filterSwitch: false,
        selectedSupplier: false,
        statesList: getCompetitionPanelStates(),
        tagList: [
            {
                order: 'Serviços mais buscados',
                tagServices: MAIN_SERVICES
            },
            {
                order: 'Outros serviços',
                tagServices: []
            }
        ],
        loadingMore: false,
        loadingFilter: false,
        loader: false,
        hasMoreSuppliers: false,
        _nextSuppliersPage: '',
        stateSelect: [],
        tag: '',
        totalSuppliers: 0,
        select2Options: {
            selectedLabel: 'Selecionado',
            selectLabel: 'Selecionar',
            noResultsLabel: 'Nenhum resultado encontrado.'
        },
        showServiceModal: false,
        lastQueriesStrings: {}
    }),
    async created() {
        this.loader = !this.loader;
        await this.getSupplierList();
        this.tagList[1].tagServices = await getServicesContractors();
        await this.checkQueriesStrings();
        this.loader = !this.loader;
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        ...mapActions('supplierNetwork', [
            'pushSupplier',
            'removeSupplier',
            'clearSuppliers',
            'selectTag',
            'removeSupplierWithSupplier'
        ]),
        addSupplier(supplier) {
            if (this.isSupplierAlreadyInSupplierList(supplier)) {
                return this.removeExistentSupplier(supplier);
            }
            if (this.supplierList.length == 5) {
                this.showNotification({ text: 'Você só pode adicionar 5 fornecedores', type: 'warning' });
            } else if (!this.supplierList.find(({ uuid }) => uuid == supplier.uuid)) {
                this.pushSupplier(supplier);
            }
        },
        noticeFilter() {
            this.showNotification({ text: 'Filtre primeiro a região e tipo de serviço que procura.', type: 'warning' });
        },
        isSupplierAlreadyInSupplierList(supplier) {
            return this.supplierList.find(({ uuid }) => uuid == supplier.uuid);
        },
        removeExistentSupplier(supplier) {
            this.removeSupplierWithSupplier(supplier);
        },
        removeSupplierOfList(index) {
            this.removeSupplier(index);
        },
        blockStateSelected(value) {
            if (this.selectedSupplier) {
                if (value == this.$route.query.ufs) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        async prepareQueriesStrings() {
            let queriesStrings = '';

            if (this.tag && this.tag.name) {
                queriesStrings = appendQueryString(queriesStrings, `categories=${this.tag.name}`);
            }

            if (this.stateSelect.length) {
                queriesStrings = appendQueryString(queriesStrings, `state=${this.stateSelect.toString()}`);
            }

            if (this._nextSuppliersPage) {
                queriesStrings = appendQueryString(queriesStrings, `page=${this._nextSuppliersPage}`);
            }

            return queriesStrings;

        },
        async getSupplierList() {
            this.loading = !this.loading;
            try {
                const queriesStrings = await this.prepareQueriesStrings();
                const suppliersResponse = await getSupplierProfileNetwork(queriesStrings);
                const isPaginateCall = queriesStrings.includes('page=');
                if (isPaginateCall) {
                    this.suppliers = this.suppliers.concat(suppliersResponse.results);
                } else {
                    this.suppliers = suppliersResponse.results;
                }
                this.totalSuppliers = suppliersResponse.count;

                if (suppliersResponse.next) {
                    this.hasMoreSuppliers = true;
                    const nextPage = getQueryStringByName(suppliersResponse.next, 'page');
                    this._nextSuppliersPage = nextPage;
                } else {
                    this.hasMoreSuppliers = false;
                }
            } catch (error) {
                this.showNotification({ text: 'Erro ao fazer a chamada de fornecedores', type: 'error' });
            } finally {
                this.loading = !this.loading;
            }
        },
        async loadMoreSuppliers() {
            this.getSupplierList();
        },
        checkService(service) {
            return this.tagList[1].tagServices.some(({ name }) => name.toUpperCase() === service.toUpperCase());
        },
        getServiceByTagList(service) {
            return this.tagList[1].tagServices.find(({ name }) => name.toUpperCase() === service.toUpperCase());
        },
        getStateByStateList(ufs) {
            if (ufs && ufs.includes('|')) {
                return ufs.split('|');
            } else {
                return [ufs];
            }
        },
        async checkQueriesStrings() {
            const service = this.$route.query.servico;
            const ufs = this.$route.query.ufs;
            if (service && this.checkService(service) && ufs) {
                this.tag = this.getServiceByTagList(service);
                this.stateSelect = this.getStateByStateList(ufs);
                if (this.competitionId) {
                    this.selectedSupplier = true;
                }
            } else if (service && this.checkService(service)) {
                this.tag = this.getServiceByTagList(service);
            } else if (ufs) {
                this.stateSelect = this.getStateByStateList(ufs);
            }
        },
        searchSuppliers({ tag, stateSelect }) {
            this.tag = tag;
            if (stateSelect && stateSelect.value) this.stateSelect = [stateSelect.value];
            this.showServiceModal = false;
        },
        pushQueryString() {
            this.$router
                .replace({
                    name: 'NetworkSuppliers',
                    query: { servico: this.tag.name, ufs: this.stateSelect.join('|') }
                })
                .catch(() => {});
        },
        redirectToStructuredQuote() {
            const query = {
                servico: this.tag && this.tag.name,
            };
            this.$router.push({
                name: 'StructuredQuote',
                query
            });
            this.clearSuppliers();
        }
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 1024;
        });
        vue.isMobile = window.innerWidth <= 1024;
        this.clearSuppliers();
    },
    computed: {
        ...mapState('supplierNetwork', ['supplierList', 'competitionId']),
        validateFilter() {
            return this.tag;
        },
        cssProps() {
            return {
                '--background': `url(${JSON.stringify(this.background)})`
            };
        },
        buttonSize() {
            return  this.isMobile ? '' : 'large'
        }
    },
    watch: {
        tag: async function() {
            this._nextSuppliersPage = '';
            this.loadingFilter = !this.loadingFilter;
            await this.getSupplierList();
            this.selectTag(this.tag);
            this.pushQueryString();
            this.loadingFilter = !this.loadingFilter;
        },
        stateSelect: async function() {
            this._nextSuppliersPage = '';
            this.loadingFilter = !this.loadingFilter;
            await this.getSupplierList();
            this.pushQueryString();
            this.loadingFilter = !this.loadingFilter;
        }
    }
};
